import {
  Component,
  OnInit,
  ChangeDetectionStrategy,
  HostListener,
  Input,
  ElementRef,
  ViewEncapsulation,
  ContentChild,
  TemplateRef,
} from '@angular/core';
import { Router } from '@angular/router';
import { ButtonComponent } from '../../button/button.component';
import { DropdownAnimation } from '../../select';
import { CheckboxComponent } from '../../checkbox/checkbox.component';

@Component({
  selector: 'app-locker',
  templateUrl: './locker.component.html',
  styleUrls: ['./locker.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.ShadowDom,
  animations: [DropdownAnimation],
})
export class LockerComponent implements OnInit {
  @Input() disabled?: boolean = false;
  @Input() locked: boolean = false;
  @Input() isIcon?: boolean = true;
  @Input() popup?: boolean = true;
  @Input() text: string = 'Функционал доступен в другом тарифе';
  @Input() color_text?: string;
  @Input() position?: 'variant' | 'center' | 'scenario' | 'side-button' | 'input' | 'input2' | 'input-label' | 'title' | 'checkbox' = 'side-button';
  isOpened: boolean = false;

  @ContentChild('button', { static: true }) button!: TemplateRef<ElementRef>;
  // @ContentChild('button', { static: true }) button!: ButtonComponent | CheckboxComponent;

  constructor(
    private _router: Router,
    private _elementRef: ElementRef,
  ) { }

  ngOnInit(): void { }

  redirectTo() {
    this._router.navigateByUrl(`private-office/tariffs-and-payment`);
    this.isOpened = false;
  }

  @HostListener('document:click', ['$event.target'])
  outsideClick(targetElement: Node | null): void {
    if (this.isOpened && !this._elementRef?.nativeElement?.contains(targetElement)) {
      this.isOpened = false;
    }
  }

  @HostListener('mouseenter', ['$event']) onMouseEnter(event: any) {
    if (this.locked) {
      this.isOpened = true;
    }
  }

  @HostListener('click', ['$event']) onMouseClick(event: any) {
    if (!this.locked) {
      if (this.button instanceof CheckboxComponent) {
        // TODO отредактировать логику для этого кейса
      }
      if (this.button instanceof ButtonComponent) {
        this.button.elementRef.nativeElement.click();
      }
    }
  }

  @HostListener('mouseleave', ['$event']) onMouseLeave(event: any) {
    this.isOpened = false;
  }
}
